(function() {
    'use strict';

    angular.module('ksef', [
            'ui.router',
            'ksef.services',
            'ksef.constants'
        ])
        .config(uiRouting);


    uiRouting.$inject = [
        '$stateProvider',
        'userPermissionsConst',
        'ksefCompanyPermissionsConst',
        'ksefCertificatePermissionsConst'
    ];

    function uiRouting(
        $stateProvider,
        userPermissionsConst,
        ksefCompanyPermissionsConst,
        ksefCertificatePermissionsConst
    ) {
        $stateProvider
            .state('layout.ksef-companies', {
                abstract: true,
                url: '/ksef/companies',
                data: {
                    title: 'KSeF',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.ksef-companies.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/ksef/views/company-list/company-list.html',
                        controller: 'KsefCompanyListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'KSeF - sprzedawcy',
                    modelPermission: ksefCompanyPermissionsConst.view
                }
            })
            .state('layout.ksef-companies.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/ksef/views/company-create/company-create.html',
                        controller: 'KsefCompanyCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'KSeF - nowy sprzedawca',
                    modelPermission: ksefCompanyPermissionsConst.add
                }
            })
            .state('layout.ksef-companies.update', {
                url: '/:pk/update',
                views: {
                    'main@layout': {
                        templateUrl: 'app/ksef/views/company-update/company-update.html',
                        controller: 'KsefCompanyUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'KSeF - edycja sprzedawcy',
                    modelPermission: ksefCompanyPermissionsConst.update
                }
            })
            .state('layout.ksef-companies.detail', {
                url: '/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/ksef/views/company-detail/company-detail.html',
                        controller: 'KsefCompanyDetailController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'KSeF - szczegóły sprzedawcy',
                    modelPermission: ksefCompanyPermissionsConst.view
                }
            }).state('layout.ksef-companies.create-company-cert', {
                url: '/:pk/create-cert',
                views: {
                    'main@layout': {
                        templateUrl: 'app/ksef/views/company-cert-create/company-cert-create.html',
                        controller: 'KsefCompanyCertCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    title: 'KSeF - nowy certyfikat sprzedawcy',
                    modelPermission: ksefCertificatePermissionsConst.add
                }
            });
    }
})();
